import { ShimmerBlock } from './Shimmer'

export function MapPageSkeleton() {
  return (
    <div className="gmap-page">
      <div className="gmap-header">
        <ShimmerBlock width={200} height={26} />
        <ShimmerBlock width={140} height={14} />
      </div>
      <div style={{ flex: 1, padding: 20 }}>
        <ShimmerBlock width="100%" height="100%" />
      </div>
    </div>
  )
}
